import { apiRegister } from '../utils/api'

/**
 * 1231	common	/common/un/city/	银联自助签约城市编号列表
 * 
 * 参数名称	参数类型	说明
 * signId	int	签约id
 */
export const commonUnCity = apiRegister('common.un.city', {
  host: 'vip',
  protoId: 1231,
  path: '/common/un/city/'
}).send
/**
 * 1229	resource/audio	/resource/image/upload/	上传图片资源
 */
export const resImageUpload = apiRegister('res.image.upload', {
      // host: 'imgcdn',
      protoId: 1229,
      timeout: 30,
      path: '/resource/image/upload/'
    }).submit
/**
 * 验证身份，获取验证码，一分钟内不可重复获取，收到的是6位数字验证码
 */
export const mobcode6 = apiRegister('passport.mobcode6', {
  protoId: 303,
  path: '/passport/mobcode6/'
}).send
/**
 * 检测验证码是否正确
 */
export const checkmobcode6 = apiRegister('passport.checkmobcode6', {
  protoId: 683,
  path: '/passport/checkmobcode6/'
}).send

/**
 * 1229	resource/audio	/resource/image/upload/	上传图片资源
 */
export const resVideoUpload = apiRegister('res.video.upload', {
  // host: 'imgcdn',
  protoId: 863,
  timeout: 60,
  path: '/resource/video/upload/'
}).submit

/**
 * 获取用户绑定账号信息
 * @accountType	int	账户类型 1:微信 2：支付宝
 * @corp	string	公司名称代号，具体参见wiki【公司基础信息】【公司名称代号】
 */
export const userMoneyInfo = apiRegister('userMoneyInfo', {
  protoId: 739,
  path: '/user/money/account/info/',
  formatQuery(query){
    query.corp          = 'xuanshang12'
  }
}).send